// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/js/" + chunkId + "." + {"216":"8f74c4c6","407":"bf5537ca","551":"596ef770","786":"07bd598c"}[chunkId] + ".js";
};